import React, { Component } from "react";
import Main_a from "./new_components/main_a";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      type: null
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  deviceDetector = () => {
    let userAgent = navigator.userAgent;  

    if (/android/i.test(userAgent) && userAgent.indexOf('Chrome') > 0) {
      this.setState({
        type: "MOBILE"
      });
    }
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.setState({
        type: "NOSUPPORT"
      });
    } else if(userAgent.indexOf('OPR') > 0){
      this.setState({
        type: 'NOSUPPORT'
      })
    } else if(userAgent.indexOf('Chrome') > 0 || userAgent.indexOf('Safari') > 0) {
      this.setState({
        type: "DESKTOP"
      });
    } else {
      this.setState({
        type: 'NOSUPPORT'
      })
    }
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    this.deviceDetector();
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState(
      {
        width: window.innerWidth,
        height: window.innerHeight
      },
      this.deviceDetector()
    );
  }

  render() {
    return <Main_a type={this.state.type} width={this.state.width} />;
  }
}

export default App;
